<template>
  <div class="audio__wrap" :class="isMe ? 'isMe' : ''">
    <audio ref="audioPlayer" controls :src="audioUrl" style="display: none" @ended="isPlaying = false" />
    <div class="self__audio">
      <div class="audio__trigger" @click="playAudioHandler">
        <template v-if="isMe">
          <div class="audio__duration">{{ duration }}{{ $t('秒') }}</div>

          <div class="audioIconBox">
            <div
              :class="{
                'wifi-symbol': true,
                'wifi-symbol--avtive': isPlaying,
              }"
            >
              <div class="wifi-circle first" />
              <div class="wifi-circle second" />
              <div class="wifi-circle third" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="audioIconBox">
            <div
              :class="{
                'wifi-symbol': true,
                'wifi-symbol--avtive': isPlaying,
              }"
            >
              <div class="wifi-circle first" />
              <div class="wifi-circle second" />
              <div class="wifi-circle third" />
            </div>
          </div>
          <div class="audio__duration">{{ duration }}{{ $t('秒') }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// 消息对话语音条
export default {
  name: 'VoiceBar',
  props: {
    src: {
      type: String,
      required: true,
    },
    // 是否为自己展示
    isMe: {
      type: Boolean,
    },
  },
  data() {
    return {
      isPlaying: false,
      duration: '',
      audioUrl: '',
    }
  },
  mounted() {
    this.setAudioUrl(this.src)
  },
  methods: {
    playAudioHandler() {
      this.isPlaying = !this.isPlaying
      const player = this.$refs.audioPlayer
      if (this.isPlaying) {
        player.load()
        player.play()
      } else {
        player.pause()
      }
    },
    setAudioUrl(url) {
      const that = this
      const options = {
        url,
        headers: { Accept: 'audio/mp3' },
        onFileDownloadComplete(response) {
          that.audioUrl = that.$WebIM.utils.parseDownloadResponse.call(that.$WebIM.conn, response)
          that.$forceUpdate()
          that.setAudioInfo()
        },
        onFileDownloadError() {
          console.log('音频下载失败')
        },
      }
      this.$WebIM.utils.download.call(this.$WebIM.conn, options)
    },
    setAudioInfo() {
      const player = this.$refs.audioPlayer
      player.load()
      const vm = this
      player.oncanplay = function () {
        vm.duration = Math.ceil(player.duration)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.audio__wrap {
  .self__audio {
    .audio__trigger {
      cursor: pointer;
      vertical-align: top;
      display: flex;
      height: 30px;
      min-width: 60px;
      background-color: #fff;
      border-radius: 0 8px 8px 8px;
      .audio__duration {
        flex: 1;
        padding: 4px 16px 4px 0;
        font-size: 16px;
        line-height: 1.4;
      }
      .audioIconBox {
        height: 100%;
        width: 30px;
        margin-left: 8px;
        position: relative;
        .wifi-symbol {
          position: relative;
          left: -0px;
          top: -10px;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          overflow: hidden;
          transform: rotate(-225deg) scale(0.5);
          .wifi-circle {
            border: 4px solid #aaaaaa;
            border-radius: 50%;
            position: absolute;
          }

          .first {
            width: 5px;
            height: 5px;
            background: #cccccc;
            top: 45px;
            left: 45px;
          }
          .second {
            width: 25px;
            height: 25px;
            top: 35px;
            left: 35px;
          }
          .third {
            width: 40px;
            height: 40px;
            top: 25px;
            left: 25px;
          }
        }
        .wifi-symbol--avtive {
          .second {
            animation: bounce 1s infinite 0.2s;
          }
          .third {
            animation: bounce 1s infinite 0.4s;
          }
        }
      }
    }
    @keyframes bounce {
      0% {
        opacity: 0; /*初始状态 透明度为0*/
      }
      100% {
        opacity: 1; /*结尾状态 透明度为1*/
      }
    }
  }
}
.isMe {
  .audio__trigger {
    background: rgba(255, 102, 0, 0.9) !important;
    border-radius: 8px 0 8px 8px !important;
  }
  .wifi-circle {
    border: 4px solid #ffffff !important;
  }
  .audio__duration {
    color: #fff !important;
    padding: 4px 0 4px 16px !important;
  }
  .audioIconBox {
    margin-left: 0 !important;
    margin-right: 8px !important;
  }
  .wifi-symbol {
    left: -21px !important;
    transform: rotate(-45deg) scale(0.5) !important;
  }
}
</style>
